import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import useResizeObserver from '@react-hook/resize-observer';
import { useState, useLayoutEffect } from 'react';

var useIsTruncated = function useIsTruncated(target) {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isTruncated = _useState2[0],
    setIsTruncated = _useState2[1];
  useLayoutEffect(function () {
    var _ref = target.current,
      clientWidth = _ref.clientWidth,
      scrollWidth = _ref.scrollWidth;

    // set initial value
    setIsTruncated(clientWidth < scrollWidth);
  }, [target]);
  useResizeObserver(target, function (entry) {
    var _entry$target = entry.target,
      clientWidth = _entry$target.clientWidth,
      scrollWidth = _entry$target.scrollWidth;

    // update value on resize
    setIsTruncated(clientWidth < scrollWidth);
  });
  return isTruncated;
};

export { useIsTruncated as default };
